import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppLogo"] */ "/vercel/path0/src/components/AppLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/vercel/path0/src/components/i18n/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/application-utilities.css");
